enum BaseShape {
  SQUARE,
  WIDE_RECTANGLE,
  LONG_RECTANGLE,
  U_SHAPE,
}

export default BaseShape;
